import React from 'react';
import { Modal, Input, Form, Select, Icon, DatePicker, Tabs, Button, Spin } from 'antd';
import BarcodeReader from "react-barcode-reader";

import moment from 'moment';
import auth from '../../../common/utility/auth';
import './styles.css';
import { message } from 'antd';
import { VALE_INGRESO } from '../../../common/types/tipoComprobanteType';
import { INGRESO } from '../../../common/types/tipoMovimientoType';
import { REGISTRADO, ANULADO, IMPORTADO } from '../../../common/types/movimientoEstadoType';
import { FORMAT_NUMBER, FORMAT_3DECIMALS } from '../../../common/types/regularExpresionType';
import {
    VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
    IMPUESTO_SELECTIVO_CONSUMO_VENTA,
    LOGISTICA_PRODUCTOS_CON_LOTE
} from '../../../common/types/parametroType';

import DetalleProductoServicioModal from './FormModal/DetalleProductoServicioModal';
import DetalleReferenciaModal from './FormModal/DetalleReferenciaModal';
import TotalDetalle from './FormModal/TotalModal';

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;



class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            result: "No result",
        };
        this.handleScan = this.handleScan.bind(this);

    }

    handleScan(data) {
        this.props.onScanerProduct(
            data,
            this.props.form.setFieldsValue,
            this.props.form.getFieldValue,
            this.handleCalculateDetail
        );
    }

    handleError(err) {
        alert("error");
        console.error(err);
    }


    findDaysAndDates = (property, value) => {
        if (property === 'fechaStr') {

            console.log('cambio 2');
            const fecha = moment(value, 'DD/MM/YYYY');
            const minFecha = fecha.format('YYYY/MM/DD');

            const gridProductos = this.props.form.getFieldValue('detalleProductos');
            const detalleProductos = this.props.formValues.listaComprobanteDetalle;
            for (var i = 0; i < detalleProductos.length; i++) {
                debugger
                var obj_current_data = gridProductos.filter(m => { return m.idProducto == detalleProductos[i].idProducto; })[0];

                detalleProductos[i].fechaVencimiento = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].fechaProduccion = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY');
                detalleProductos[i].flagAfecto = obj_current_data.flagAfecto;
                detalleProductos[i].precioUnitario = obj_current_data.precioUnitario;
                detalleProductos[i].cantidad = obj_current_data.cantidad;
                detalleProductos[i].subTotal = obj_current_data.subTotal;
                detalleProductos[i].igv = obj_current_data.igv;
                detalleProductos[i].total = obj_current_data.total;
                detalleProductos[i].lote = obj_current_data.lote;
                detalleProductos[i].numeroRegistroSanitario = obj_current_data.numeroRegistroSanitario;
                detalleProductos[i].minFechaStr = minFecha;
            }

            this.props.form.setFieldsValue({ listaComprobanteDetalle: detalleProductos });
        }
    }

    handleCompleteDecimals = (property, value) => {
        if (value === '' || isNaN(parseFloat(value).toFixed(3)))
            this.props.form.setFieldsValue({ [property]: '0.000' });
        else
            this.props.form.setFieldsValue({ [property]: parseFloat(value).toFixed(3) });
    }

    fetchNewValue = (value, numberDecimals) => {
        if (numberDecimals === 2)
            return value === '' || isNaN(parseFloat(value).toFixed(2)) ? 0 : parseFloat(value);
        if (numberDecimals === 3)
            return value === '' || isNaN(parseFloat(value).toFixed(3)) ? 0 : parseFloat(value);
        if (numberDecimals === 5)
            return value === '' || isNaN(parseFloat(value).toFixed(5)) ? 0 : parseFloat(value);

        return 0;
    };

    fetchFieldValue = (identifier, property) => {
        var result = parseFloat(this.props.form.getFieldValue(`${property}[${identifier}]`));
        return result;
    };

    fetchFieldValueSum = (identifier, property, paramValue) => {
        var suma = 0;
        var obj = Object.assign({}, this.props.form.getFieldValue(property));

        for (var [key, value] of Object.entries(obj)) {
            suma = suma + (key === identifier ? paramValue : parseFloat(value));
        }

        return suma;
    };


    fetchSumaTotalAfecto = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 10 o 17
            var esGravado = ["10", "17"].includes(codigo);

            if (esGravado) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalInafecto = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 30
            const esInafecto = ["30"].includes(codigo);


            if (esInafecto) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalExonerado = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 20
            const esExonerado = ["20"].includes(codigo);

            if (esExonerado) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };


    fetchSumaTotalGratuito = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 20
            const esGratuito = !["10", "20", "30", "40", "17"].includes(codigo);

            if (esGratuito) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };

    fetchSumaTotalExportacion = (
        identifier,
        codex,
        total
    ) => {
        let suma = 0;

        const arrTotal = this.props.form.getFieldValue("arrTotal");
        const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

        for (const [key, value] of Object.entries(arrTotal)) {

            // 👉 obtenemos el id del impuesto
            const impuestoKey = arrImpuesto?.[key]?.key;

            const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
                x => x.id === impuestoKey
            );

            const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

            // ✅ solo sumar si es 40
            const esGratuito = ["40"].includes(codigo);

            if (esGratuito) {
                suma +=
                    identifier === key
                        ? Number(total.toFixed(2))
                        : parseFloat(value);
            }
        }

        return suma;
    };

    handleCalculateDetail = (row, property, value, numberDecimals) => {
        var identifier = row.identifier;
        var newValue = this.fetchNewValue(value, numberDecimals);
        var params = auth.user().parametros;
        // Datos de parametro //
        var porcentajeIGV = 18;
        var porcentajeISC = parseFloat(params.filter(m => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA)[0].valor);
        var flagPrecioIncluyeIGV = params.filter(m => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;
        var flagVencimiento = row.flagVencimiento;// property === "arrFlagVencimiento" ? value : this.props.form.getFieldValue(`arrFlagVencimiento[${row.identifier}]`);

        // Datos por fila //
        var fechaVencimiento = property === "arrFechaVencimiento" ? value : this.props.form.getFieldValue(`arrFechaVencimiento[${identifier}]`);
        var fechaProduccion = property === "arrFechaProduccion" ? value : this.props.form.getFieldValue(`arrFechaProduccion[${identifier}]`);
        var idProducto = property === "arrIdProducto" ? value : this.props.form.getFieldValue(`arrIdProducto[${identifier}]`);


        var cantidad = property === "arrCantidad" ? newValue : this.fetchFieldValue(identifier, "arrCantidad");
        var precioUnitario = property === "arrPrecioUnitario" ? newValue : this.fetchFieldValue(identifier, "arrPrecioUnitario");
        var precioNuevo = property === "arrPrecio" ? newValue : this.fetchFieldValue(identifier, "arrPrecio");

        var total = property === "arrTotal" ? newValue : this.fetchFieldValue(identifier, "arrTotal");
        var lote = property === "arrLote" ? value : this.props.form.getFieldValue(`arrLote[${identifier}]`);
        var numeroRegistroSanitario = property === "arrNumeroRegistroSanitario" ? value : this.props.form.getFieldValue(`arrNumeroRegistroSanitario[${identifier}]`);

        var flagAfecto = false;
        var flagExonerado = false;
        var flagGratuito = false;
        var flagISC = false;

        var flagChangeTotal = false;

        var getImpuesto =
            property === "arridImpuesto"
                ? value
                : this.props.form.getFieldValue(`arridImpuesto[${row.identifier}]`).key;


        const selectedImpuesto = this.props.formValues.tipoAfectacion.find(x => x.id === getImpuesto);

        const DEFAULT_CODIGO = '10';
        const codigo = selectedImpuesto?.codigoSunat ?? DEFAULT_CODIGO;

        switch (true) {

            // Gravado
            case ["10", "17"].includes(codigo):
                flagAfecto = true;
                break;

            // Exonerado
            case codigo === "20":
                flagExonerado = true;
                break;

            // Inafecto
            case codigo === "30":
                break;

            // Exportación
            case codigo === "40":
                break;
        }



        // VALIDACION CASOS EXONERADOS INAFECTOS //

        if (!flagAfecto || flagExonerado) {
            flagPrecioIncluyeIGV = 0;
        }


        // Datos por fila (bloquear checks) //


        if (flagAfecto && property == "arrFlagAfecto") {
            flagExonerado = false;
        }

        if (flagExonerado && property == "arrFlagExonerado") {
            flagAfecto = false;
            precioNuevo = precioUnitario
            precioUnitario = precioUnitario
        }


        if (property === "arrFlagAfecto") {
            precioNuevo = value ? (precioUnitario * 1.18) : precioUnitario;

        }

        /*********** Calculo precios unitarios ********/
        var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
        var precioUnitarioSinIGV = flagPrecioIncluyeIGV
            ? precioNuevo / divisorCalculoSubTotal
            : precioUnitario;


        if (flagAfecto) {

            if (property === "arrPrecio") {
                precioUnitario = (precioNuevo / 1.18)
            }

            if (property === "arrPrecioUnitario") {
                precioNuevo = (precioUnitario * 1.18)
            }

            if (property === "arrCantidad" || property === "arrTotal") {
                precioUnitario = precioNuevo == 0 ? (precioUnitario * 1.18) : (precioNuevo / 1.18)
            }

        } else {

            if (property === "arrPrecio") {
                precioNuevo = precioNuevo
                precioUnitario = precioNuevo
            }

            if (property === "arrPrecioUnitario") {
                precioUnitario = precioUnitario
                precioNuevo = precioUnitario
            }

            if (property === "arridImpuesto" && codigo == "40") {
                precioUnitario = precioNuevo
            }
        }



        var totalDetalle = cantidad * precioUnitario;

        // Calculo totales //
        var subTotal = totalDetalle;
        var igv = parseFloat((flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2));
        var total = parseFloat(((subTotal + igv)).toFixed(2));

        // Arr Detalle //
        var detalle = {
            identifier,
            idProducto: row.idProducto,
            nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
            flagAfecto,
            flagExonerado,
            flagVencimiento,
            precioUnitario,
            precioNuevo,
            cantidad,
            subTotal,
            igv,
            total,
            lote,
            flagAplicarSerie: row.flagAplicarSerie,
            listaDetalleSerie: row.listaDetalleSerie,
            numeroRegistroSanitario: (numeroRegistroSanitario == null || numeroRegistroSanitario == undefined) ? null : numeroRegistroSanitario,
            fechaVencimiento: (fechaVencimiento == null || fechaVencimiento == undefined) ? null : fechaVencimiento.format('DD/MM/YYYY'),
            fechaProduccion: (fechaProduccion == null || fechaProduccion == undefined) ? null : fechaProduccion.format('DD/MM/YYYY'),
            idImpuesto: selectedImpuesto?.id ?? 1,

        };

        var detalleProductos = this.props.form.getFieldValue("detalleProductos");
        var detalleProductosFilter = detalleProductos.filter(m => { return m.identifier !== identifier });
        detalleProductosFilter.push(detalle);


        var sumaTotalAfecto = this.fetchSumaTotalAfecto(
            row.identifier,
            codigo,
            total
        );
        var sumaTotalInafecto = this.fetchSumaTotalInafecto(
            row.identifier,
            codigo,
            total
        );

        var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
            row.identifier,
            codigo,
            total
        );

        var fetchSumaTotalGratuito = this.fetchSumaTotalGratuito(
            row.identifier,
            codigo,
            total
        );

        var sumaTotalExportacion = this.fetchSumaTotalExportacion(
            row.identifier,
            codigo,
            total
        );
        // Calculo suma detalle //
        var sumaTotal = parseFloat(this.fetchFieldValueSum(row.identifier, "arrTotal", total).toFixed(2));
        var sumaSubTotal = parseFloat(
            (
                sumaTotalAfecto / divisorCalculoSubTotal +
                (sumaTotalInafecto + fetchSumaTotalExonerado + sumaTotalExportacion)
            ).toFixed(2)
        );
        
        sumaTotal = sumaTotal - fetchSumaTotalGratuito;
        var sumaIgv = (sumaTotal) - sumaSubTotal;
        var sumaTotalDetalle = sumaSubTotal;


        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,
            detalleProductos: detalleProductosFilter,
            [`arrFlagAfecto[${identifier}]`]: flagAfecto,
            [`arrFlagExonerado[${identifier}]`]: flagExonerado,

            [`arrNumeroRegistroSanitario[${identifier}]`]: numeroRegistroSanitario,
            [`arrLote[${identifier}]`]: lote,
            [`arrFechaVencimiento[${identifier}]`]: fechaVencimiento,
            [`arrFechaProduccion[${identifier}]`]: fechaProduccion,
            [`arrPrecioUnitario[${identifier}]`]: precioUnitario.toFixed(5),
            [`arrPrecio[${identifier}]`]: precioNuevo.toFixed(5),

            [`arrCantidad[${identifier}]`]: cantidad.toFixed(3),
            [`arrSubTotal[${identifier}]`]: subTotal.toFixed(2),
            [`arrIgv[${identifier}]`]: igv.toFixed(2),
            [`arrTotal[${identifier}]`]: total.toFixed(2)
        });

        this.props.form.setFieldsValue({
            detalleProductos: detalleProductosFilter
        });
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    };

    handleOk = (e) => {
        debugger
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {

                var params = auth.user().parametros;
                var porcentajeIGV = 18;// 
                const mostrarVencimiento = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;

                const form = {
                    "id": values.id,
                    "idTipoMovimiento": INGRESO.ID,
                    "idEntidad": values.idEntidad,
                    "idConcepto": values.idConcepto.key,
                    "idAlmacen": values.idAlmacen.key,
                    "idMoneda": values.idMoneda.key,
                    "idTipoAlmacen": values.idTipoAlmacen.key,
                    "orden": 1,
                    "idTipoComprobante": VALE_INGRESO.ID,
                    "serie": "I001",
                    "documento": null,
                    "fecha": null,
                    "fechaStr": values.fechaStr.format('DD/MM/YYYY'),
                    "tipoCambio": parseFloat(values.tipoCambio),
                    "porcentajeIGV": porcentajeIGV,
                    "subTotal": values.sumaSubTotal,
                    "igv": values.sumaIgv,
                    "total": values.sumaTotal,
                    "peso": null,
                    "observacion": values.observacion,
                    "fechaActivacion": null,
                    "idMovimientoEstado": REGISTRADO,
                    "movimientoDetalles": [],
                    "movimientoReferencias": [],
                    "idOrdenCompra": values.idOrdenCompra,
                    "idProyecto": values.idProyecto === undefined ? 0 : values.idProyecto.key,
                    "movimientoReferencias": this.fetchReferencias(values)
                }
                // DEVOLUCIÓN RECIBIDA ---05
                // DEVOLUCIÓN ENTREGADA ---06
                var conceptos = values.concepto;
                conceptos = conceptos.filter(e => e.id == values.idConcepto.key)

                if (form.movimientoReferencias.length <= 0 && ["02", "05", "21"].includes(conceptos[0].codigoSunat)) {
                    message.warning('Debe de ingresar como mínimo 1 referencia.');
                    return;
                }

                if (values.detalleProductos.length <= 0) {
                    message.warning('Debe de ingresar como mínimo 1 producto.');
                    return;
                }
                debugger;
                if (values.detalleProductos.filter(m => { return m.flagAplicarSerie === true; }).length > 0) {
                    values.detalleProductos.forEach(row => {
                        if (row.listaDetalleSerie.length === 0 && row.flagAplicarSerie) {
                            message.warning("Por favor agregue las series para el producto " + row.nombre);
                            return false;
                        }
                    });
                }

                if (values.sumaTotal === 0) {
                    message.warning('Por favor ingrese lo montos de forma correcta.');
                    return;
                }

                var count_detalles = values.detalleProductos.length;
                var _fechaVcto = null;
                var _fechaProd = null;
                for (var i = 0; i < count_detalles; i++) {
                    var det = values.detalleProductos[i];

                    if (mostrarVencimiento) {
                        _fechaProd = typeof (det.fechaProduccion) === "string" ? det.fechaProduccion : det.fechaProduccion.format('DD/MM/YYYY')
                    }
                    _fechaVcto = det.fechaVencimiento == null ? null : (typeof (det.fechaVencimiento) === "string" ? det.fechaVencimiento : det.fechaVencimiento.format('DD/MM/YYYY'));

                    const itemDet = {
                        "id": 0,
                        "idMovimiento": 0,
                        "idProducto": parseInt(det.idProducto),
                        "nombre": det.nombre,
                        "flagAfecto": det.flagAfecto,
                        "flagExonerado": det.flagExonerado,
                        "flagVencimiento": det.flagVencimiento,
                        "cantidad": det.cantidad,
                        "precioUnitario": det.precioNuevo,
                        "valorUnitario": det.precioUnitario,
                        "ListaMovimientoDetalleSerie": det.listaDetalleSerie,
                        "subTotal": det.subTotal,
                        "igv": det.igv,
                        "total": det.total,
                        "fecha": null,
                        "fechaVencimientoStr": _fechaVcto,
                        "fechaProduccionStr": _fechaProd,
                        "numeroLote": det.lote,
                        "numeroRegistroSanitario": mostrarVencimiento ? det.numeroRegistroSanitario : null,
                        "item": null,
                        "precioPromedio": null,
                        "subtotalPromedio": null,
                        "totalPromedio": null,
                        "precioUnitarioPrueba": null,
                        "idImpuesto": det.idImpuesto,
                        "operacion": null
                    }

                    form.movimientoDetalles.push(itemDet);
                }

                this.props.onSave(form, this.props.form);
            }
        });
    }

    fetchReferencias = (values) => {

        var result = [];
        var keys = [];
        var obj = Object.assign({}, values.arrIdTipoComprobante);

        for (var [key] of Object.entries(obj)) {
            keys.push(key);
        }
        keys.forEach((key) => {
            result.push({
                idTipoComprobante: values.arrIdTipoComprobante[key].key,
                serie: values.arrSeries[key],
                documento: values.arrDocumentos[key],
                idReferencia: values.arrIdReferencia[key],
                idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
                flagInterno: values.arrFlagInterno[key],
            });
        });

        return result;
    };


    onChangeEntidad = (a, element) => {

        this.props.form.setFieldsValue(
            {
                documentoEntidad: element.props.data.numeroDocumento,
            },
            () => {
                this.props.onChange(
                    "idEntidad",
                    element.props.data.idEntidad,
                    this.props.form
                );
            }
        );
    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.props.onChangeNameProduct(row);
    }

    handleRemoverProducto = (row) => {

        var detalleProductos = this.props.form.getFieldValue("detalleProductos");
        var detalleProductosFilter = detalleProductos.filter((m) => {
            return m.identifier !== row.identifier;
        });


        var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
        var sumaSubTotal = this.fetchFieldValueSum(
            row.identifier,
            "arrSubTotal",
            0
        );
        var sumaIgv = sumaTotal - sumaSubTotal;
        var sumaTotalDetalle = sumaSubTotal;

        // Calculo de Totales 2 //

        this.props.form.setFieldsValue({
            sumaTotal: sumaTotal,
            sumaSubTotal: sumaSubTotal,
            sumaIgv: sumaIgv,
            sumaTotalDetalle: sumaTotalDetalle,
            detalleProductos: detalleProductosFilter
        });

        this.props.onRemoverProducto(row, this.props.form);
    };

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('detalleProductos', { initialValue: this.props.formValues.detalleProductos });
        getFieldDecorator('listaComprobanteReferencia', { initialValue: this.props.formValues.listaComprobanteReferencia });
        getFieldDecorator("flagReferencia", {
            initialValue: false,
        });
        getFieldDecorator('sumaSubTotal', { initialValue: this.props.formValues.sumaSubTotal });
        getFieldDecorator('sumaIgv', { initialValue: this.props.formValues.sumaIgv });
        getFieldDecorator('sumaTotal', { initialValue: this.props.formValues.sumaTotal });
        getFieldDecorator('concepto', { initialValue: this.props.formValues.conceptos });

        return (
            <Modal
                title={(<div>Registrar Ingresos</div>)}
                visible={this.props.visible}
                style={{ top: 30 }}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                width="1200px"
            >
                <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

                <Form>
                    {getFieldDecorator('id', { initialValue: this.props.formValues.id })(
                        <input type="hidden" />
                    )}

                    {getFieldDecorator('idOrdenCompra', { initialValue: this.props.formValues.idOrdenCompra })(
                        <input type="hidden" />
                    )}

                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '65%' }}>
                                        {getFieldDecorator('fechaStr', {
                                            initialValue: moment(this.props.formValues.fechaStr, 'DD/MM/YYYY'),
                                            rules: [{
                                                type: 'object',
                                                required: true,
                                                message: 'Requerido'
                                            }],
                                        })(
                                            <DatePicker
                                                disabled={!this.props.formValues.flagClaim}
                                                className="first-input"
                                                placeholder="Seleccione fecha"
                                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                format="DD/MM/YYYY"
                                                onChange={
                                                    (moment, value) => {
                                                        this.props.onChange('fechaStr', value);
                                                        this.findDaysAndDates('fechaStr', value);
                                                    }
                                                }
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '35%' }}>
                                        {getFieldDecorator('tipoCambio', {
                                            initialValue: parseFloat(this.props.formValues.tipoCambio).toFixed(3),
                                            rules: [{
                                                required: true,
                                                pattern: new RegExp(FORMAT_3DECIMALS),
                                                message: "Formato decimal incorrecto (0.000)"
                                            }]
                                        })(
                                            <Input
                                                className="text-right second-input"
                                                placeholder="Ingresar Tipo de Cambio"
                                                autoComplete="off"
                                                onBlur={(e) => this.handleCompleteDecimals("tipoCambio", e.target.value)}
                                            />
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '40%' }}>
                                        {getFieldDecorator('serie', {
                                            initialValue: this.props.formValues.serie
                                        })(
                                            <Input
                                                placeholder="Serie"
                                                autoComplete="off"
                                                className="first-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                    <Form.Item style={{ width: '60%' }}>
                                        {getFieldDecorator('documento', {
                                            initialValue: this.props.formValues.documento
                                        })(
                                            <Input
                                                placeholder="Documento"
                                                autoComplete="off"
                                                className="second-input"
                                                disabled={true}
                                            />
                                        )}
                                    </Form.Item>
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idMoneda', option.key)}
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 form-group">
                            <Form.Item label="Proveedor/Entidad">
                                <InputGroup compact>
                                    <Form.Item style={{ width: '100%' }}>
                                        {getFieldDecorator('idEntidad', {
                                            initialValue: this.props.formValues.idEntidad || undefined,
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio.',
                                            }]
                                        })(
                                            <Select
                                                showSearch
                                                placeholder="Seleccione Entidad"
                                                optionFilterProp="children"
                                                className="second-input"
                                                notFoundContent={this.props.fetching ? <Spin size="small" /> : null}
                                                filterOption={false}

                                                onSearch={this.props.fetchClientes}
                                                onSelect={(value, option) => {
                                                    this.props.onChangeEntidad(value, this.props.form)
                                                }}
                                            >
                                                {this.props.formValues.entidades.map(item => (
                                                    <Option key={item.id} value={item.id}>
                                                        {item.razonSocial + ' - ' + item.tipoDocumento + ' - ' + item.numeroDocumento}
                                                    </Option>
                                                ))}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-4 form-group">
                            <Form.Item label="Concepto">
                                {getFieldDecorator('idConcepto', {
                                    initialValue: this.props.formValues.idConcepto ?
                                        { key: this.props.formValues.idConcepto } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Concepto"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.onChange("idConcepto", option.key)
                                        }}
                                    >
                                        {this.props.formValues.conceptos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">


                        <div className="col-md-4 form-group">
                            <Form.Item label="Establecimiento">
                                {getFieldDecorator('idEstablecimiento', {
                                    initialValue: this.props.formValues.idEstablecimiento ?
                                        { key: this.props.formValues.idEstablecimiento } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Establecimiento"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.form.setFieldsValue({ idTipoAlmacen: undefined });
                                            this.props.onChange("idEstablecimiento", option.key, this.props.form)
                                        }}
                                    >
                                        {this.props.formValues.establecimientos.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Tipo Almacén">
                                {getFieldDecorator('idTipoAlmacen', {
                                    initialValue: this.props.formValues.idTipoAlmacen ?
                                        { key: this.props.formValues.idTipoAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        onChange={(option) => {
                                            this.props.form.setFieldsValue({ idAlmacen: undefined });
                                            this.props.onChange("idTipoAlmacen", option.key, this.props.form)
                                        }}                                    >
                                        {this.props.formValues.TipoAlmacen.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Almacén">
                                {getFieldDecorator('idAlmacen', {
                                    initialValue: this.props.formValues.idAlmacen ?
                                        { key: this.props.formValues.idAlmacen } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Almacén"}
                                        optionFilterProp="children"
                                        loading={this.props.formValues.almacenLoading}
                                    >
                                        {this.props.formValues.almacenes.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-9 form-group">
                            <Form.Item label="Observación">
                                {getFieldDecorator('observacion', {
                                    initialValue: this.props.formValues.observacion
                                })(
                                    <Input
                                        placeholder="Ingresar Observación"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-3 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('idProyecto', {
                                    initialValue: this.props.formValues.idProyecto ?
                                        { key: this.props.formValues.idProyecto } : undefined
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Proyecto"}
                                        optionFilterProp="children"
                                        onChange={(option) => this.props.onChange('idProyecto', option.key)}
                                    >
                                        <Option key={0} value={0}>
                                            <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                        </Option>
                                        {this.props.formValues.proyectos.map(item => (
                                            item.estado ?
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                                : null
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                                // tabBarExtraContent={
                                //     <Button
                                //         icon="plus"
                                //         type="primary"
                                //         onClick={this.props.onAgregarDetalle}
                                //     >
                                //         Agregar
                                //     </Button>
                                // }
                                tabBarExtraContent={
                                    <div className="custom-options">
                                        {/* <Button
                                    icon="import"
                                    type="primary"
                                      onClick={() =>
                                        this.props.onImportarOrdenCompra(
                                          this.props.form.setFieldsValue,
                                          this.props.form.getFieldValue
                                        )
                                      }
                                >
                                    Importar Orden de Compra
                                </Button> */}
                                        <Button
                                            icon="import"
                                            hidden
                                            type="primary"
                                            onClick={() =>
                                                this.props.onImportarOrdenProduccion(
                                                    this.props.form.setFieldsValue,
                                                    this.props.form.getFieldValue
                                                )
                                            }
                                        >
                                            Importar Orden de Producción
                                        </Button>
                                        <Button
                                            icon="plus"
                                            type="primary"
                                            onClick={() =>
                                                this.props.onAgregarDetalle(
                                                    this.props.form.setFieldsValue,
                                                    this.props.form.getFieldValue
                                                )
                                            }
                                        >
                                            Agregar
                                        </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Detalle de Productos y Servicios" key="1">
                                    <DetalleProductoServicioModal
                                        dataSource={this.props.formValues.listaComprobanteDetalle}
                                        // onRemove={this.props.onRemoverProducto}
                                        onRemove={this.handleRemoverProducto}
                                        onAgregarSerie={this.props.onAgregarSerie}
                                        onCalculateDetail={this.handleCalculateDetail}
                                        onGetFieldDecorator={getFieldDecorator}
                                        onGetFieldValue={getFieldValue}
                                        onSetFieldsValue={setFieldsValue}
                                        onChangeNameProduct={this.handleChangeNameProduct}
                                        tipoAfectacion={this.props.formValues.tipoAfectacion}
                                    />
                                </TabPane>
                                <TabPane tab="Detalle de Referencias" key="2">
                                    <DetalleReferenciaModal
                                        dataSource={this.props.formValues.listaComprobanteReferencia}
                                        tiposComprobante={this.props.formValues.tiposComprobante}
                                        onRemove={this.props.onRemoverReferencia}
                                        onGetFieldDecorator={getFieldDecorator}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                    <TotalDetalle
                        formValues={this.props.formValues}
                        onGetFieldDecorator={getFieldDecorator}
                        onGetFieldValue={getFieldValue}
                    />

                </Form>
            </Modal>
        )
    }
}
export default Form.create()(FormModal)